import React, { Component, useState } from "react"
import "./Borrowers.css"
import 'bootstrap/dist/css/bootstrap.min.css'
import '../App.css'
import { Row, Col, Form, Button as But } from 'react-bootstrap'
import { Button, Input, Space, Table, Skeleton, Switch, Tag, Modal, Select, Spin, Dropdown, Tooltip, message } from 'antd'
import { SearchOutlined, CloseOutlined, ExclamationCircleFilled } from '@ant-design/icons'
import Highlighter from 'react-highlight-words'
import * as com from '../Common'
import { UR_LoanOfficer, UR_Owner, UR_Underwriter, UR_Closer, UR_LoanOfficerManager } from "../State"
import { capitalize } from "lodash"
import { checkAccess } from "../Auth"
import { CaretDownOutlined } from '@ant-design/icons'
import { withRouter } from "react-router-dom"
import BulkChangeModal from "./BulkChangeModal.tsx";
import LoanBorrowerPopUp from "../Common/components/loanOrBorrow"
import ImportMISMOFile from "../Common/components/ImportMISMOFile/index"
import * as brwr from "../Store/borrower"
import { connect } from 'react-redux'
import TodoIcon from "./components/ToDo"
import { StageForm, StatusForm } from "./components/StageStatus"
import CurrentStage from "BorrowerStageStatus/Header/CurrentStage"
import CurrentStatus from "BorrowerStageStatus/Header/CurrentStatus"
import UpdateLoanModal from "./components/UpdateLoanStatus"
import dayjs from "dayjs"
import { CLOSING_FILTERS, closeOfEscrowFlag, compareCloseOfEscrow, matchesClosingFilter } from "Common/utils/closeOfEscrow"
import { SELECTION_COLUMN_WIDTH, columnsWidth, compareLoanAmount, compareState, formatLoanAmount } from "./loanListFields"
import { track } from 'statsig'
import { STATSIG, PAGE } from 'statsig/events'

const currentLoanStatuses = [
    'interviewstarted', 'interviewfinished', 'documentationrequested',
    'loansubmitted', 'conditionallyapproved', 'applicationwithdrawn', 'applicationdenied',
    "pendingrateselection", "readyforsubmit", "indocs", "fundsreleased"
]

const sourceNameMap = {
    "sunny": "From Sunny",
    "socialmedia": "Social Media",
    "friend": "Friend Referral",
    "website": "Website"
}

/** Funded, withdrawn, denied... the loan has closed one way or another, so its close of escrow date is no longer flagged or filtered. */
function loanHasClosed(record) {
    return record.currentStage === "Disposed" ||
        (com.CurrentStatus[record.currentStatus] || 0) >= com.CurrentStatus.LoanFunded
}

/** Mirrors content sidebar progressIndicator completeness (percent === 100). */
function isCoborrowerInfoComplete(completedSteps = {}, hasCoborrower = '') {
    const steps = completedSteps && typeof completedSteps === 'object' ? completedSteps : {}
    let totalSteps = 0
    let completedCount = 0

    if (hasCoborrower !== 'remote') {
        totalSteps += 3
        if (steps.yourinfo) completedCount += 1
        if (steps.residence) completedCount += 1
        if (steps.property) completedCount += 1
    }
    totalSteps += 8
    if (steps.employment) completedCount += 1
    if (steps.otherincome) completedCount += 1
    if (steps.assets) completedCount += 1
    if (steps.realestate) completedCount += 1
    if (steps.liabilities) completedCount += 1
    if (steps.propertymoney) completedCount += 1
    if (steps.finances) completedCount += 1
    if (steps.creditcheck) completedCount += 1

    if (totalSteps === 0) return false
    return Math.round((completedCount / totalSteps) * 100) === 100
}

function mapCoBorrowersFromApi(coBorrowers = []) {
    return (coBorrowers || []).map((coBorrower) => {
        let completedSteps = coBorrower.CompletedSteps || {}
        if (typeof completedSteps === 'string') {
            try {
                completedSteps = JSON.parse(completedSteps || '{}')
            } catch (_err) {
                completedSteps = {}
            }
        }
        return {
            partyId: coBorrower.PartyID,
            name: `${coBorrower.FirstName || ''} ${coBorrower.LastName || ''}`.trim() || coBorrower.Email || '-',
            email: coBorrower.Email || '',
            phone: coBorrower.Phone || '',
            completedSteps,
        }
    })
}

const mapDispatchToProps = (dispatch) => ({
    changeBorrowerLoanId: (id) => {
        dispatch(brwr.ChangeBorrowerLoanId(id))
    },
    changeBorrowerId: (id) => {
        dispatch(brwr.ChangeBorrowerId(id))
    }
})

const { confirm } = Modal
const updateLoanProcessor = (loanid, slpid, role, onHide) => {
    let token = sessionStorage.getItem("ZeitroA")
    fetch('/los/updateloanteam', {
        body: JSON.stringify({ LoanID: loanid, LOID: slpid, Role: role }),
        method: 'POST',
        headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache"
        }
    }).then(
        response => {
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' +
                    response.status)
                onHide()
                return
            } else {
                const roleMap = {
                    LoanProcessor: 'processor',
                    Underwriter: 'underwriter',
                    Closer: 'closer',
                }
                if (roleMap[role]) {
                    track(STATSIG.LOANS.LOAN_ASSIGN, 'single', {
                        type: 'single',
                        count: 1,
                        loan_ids: [loanid],
                    })
                }
                onHide()
            }
        }
    ).catch(function (err) {
        console.log('Fetch Error :-S', err)
    })
}

function AssignLoanProcessor(props) {

    const [slpid, setSlpid] = useState("")
    const handleSubmit = event => {
        updateLoanProcessor(props.loan_id, slpid, "LoanProcessor", props.onHide)
    }
    const showOptions = () => {
        const selected = e => {
            setSlpid(e.target.value)
        }

        return (
            <Row className="mt-1">
                <Col className="px-0">
                    <Form.Group controlId="propertytype" className="text-left" >
                        <Form.Control name="propertytype" as="select"
                            defaultValue={props.lp_id}
                            type="text"
                            required
                            onChange={selected}
                            style={{ fontSize: 14, borderRadius: 6, border: "1px solid #ECECEC" }}
                        >
                            <option value="" >Select loan processor</option>

                            {props.loanprocessors.map(t => {
                                return (
                                    <option value={t.id}>{t.firstname} {t.lastname}</option>
                                )
                            }
                            )
                            }
                        </Form.Control>
                        <Form.Control.Feedback >Looks good!</Form.Control.Feedback>
                        <Form.Control.Feedback type="invalid">
                            Please select loan processor.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
        )

    }
    const showNotes = () => {
        if (slpid === "") return <></>
        const newLpName = props.loanprocessors.find(t => t.id === slpid).firstname + " " + props.loanprocessors.find(t => t.id === slpid).lastname
        if (props.lpName === newLpName) return <></>
        return (
            <Row style={{ marginTop: -10 }}>
                <Col className="px-0">
                    <div style={titleStyle}>*{newLpName} will replace {props.lpName} as the borrower's loan processor</div>
                </Col>
            </Row>
        )
    }
    const titleStyle = { fontSize: 12, color: "#6E6E70", fontWeight: 500 }
    return (
        <Modal
            {...props}
            title="Assign loan processor to the borrower"
            open={props.show}
            onCancel={props.handleClose}
            onOk={handleSubmit}
            okText="Submit"
            okButtonProps={{
                disabled: slpid === "",
            }}
        >
            <div className="pt-3 pb-3">

                <Row style={{ borderRadius: 6, backgroundColor: "#F5F5F7", padding: "15px 23px" }}>
                    <Col>
                        <div style={titleStyle}>Borrower</div>
                        <div>{props.name}</div>
                    </Col>
                    <Col>
                        <div style={titleStyle}>Assigned Loan Processor</div>
                        <div>{props.lpName}</div>
                    </Col>
                </Row>

                <Row className="mt-3">
                    <Col className="px-0">
                        <div style={titleStyle}>Loan Processor</div>
                        <div>
                            {showOptions()}
                        </div>
                    </Col>
                </Row>
                {showNotes()}


            </div>
        </Modal>
    )
}

function AssignLoanOfficer(props) {

    const updateLoanOfficer = (id, sid) => {
        let token = sessionStorage.getItem("ZeitroA")
        let body = { loanid: id, losid: sid }
        fetch('/los/assignlostoborrower', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            },
        }).then(
            response => {
                if (response.status !== 200) {
                    alert('Looks like there was a problem. Status Code: ' +
                        response.status)
                    props.onHide()
                    return
                }
                response.json().then(js => {
                    if (js.Status !== "OK") {
                        alert("Error: " + js.Text)
                        props.onHide()

                    } else {
                        track(STATSIG.LOANS.LOAN_ASSIGN, 'single', {
                            type: 'single',
                            count: 1,
                            loan_ids: [id],
                        })
                        props.onHide()

                    }
                })
            }
        ).catch(function (err) {
            alert('Fetch Error :-S', err)
        })
    }
    const [sid, setSid] = useState("")
    const handleSubmit = event => {
        updateLoanOfficer(props.loan_id, sid)
    }
    const showOptions = () => {
        const selected = e => {
            setSid(e.target.value)
        }

        return (
            <Row className="mt-1">
                <Col className="px-0">
                    <Form.Group controlId="propertytype" className="text-left" >
                        <Form.Control name="propertytype" as="select"
                            defaultValue={props.los_id}
                            type="text"
                            required
                            onChange={selected}
                            style={{ fontSize: 14, borderRadius: 6, border: "1px solid #ECECEC" }}
                        >
                            <option value="" >Select loan officer</option>

                            {props.loanofficers.map(t => {
                                return (
                                    <option value={t.id}>{t.firstname} {t.lastname}</option>
                                )
                            }
                            )
                            }
                        </Form.Control>
                        <Form.Control.Feedback >Looks good!</Form.Control.Feedback>
                        <Form.Control.Feedback type="invalid" >
                            Please select loan officer.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
        )

    }
    const showNotes = () => {
        if (sid === "") return <></>
        const newLOName = props.loanofficers.find(t => t.id === sid).firstname + " " + props.loanofficers.find(t => t.id === sid).lastname
        if (props.loName === newLOName) return <></>
        return (
            <Row style={{ marginTop: -10 }}>
                <Col className="px-0">
                    <div style={titleStyle}>*{newLOName} will replace {props.loName} as the borrower's loan officer</div>
                </Col>
            </Row>
        )
    }
    const titleStyle = { fontSize: 12, color: "#6E6E70", fontWeight: 500 }
    return (
        <Modal
            {...props}
            title="Assign loan officer to the borrower"
            open={props.show}
            onCancel={props.handleClose}
            onOk={handleSubmit}
            okText="Submit"
            okButtonProps={{
                disabled: sid === "",
            }}
        >
            <div className="pt-3 pb-3">

                <Row style={{ borderRadius: 6, backgroundColor: "#F5F5F7", padding: "15px 23px" }}>
                    <Col>
                        <div style={titleStyle}>Borrower</div>
                        <div>{props.name}</div>
                    </Col>
                    <Col>
                        <div style={titleStyle}>Assigned Loan Officer</div>
                        <div>{props.loName}</div>
                    </Col>
                </Row>

                <Row className="mt-3">
                    <Col className="px-0">
                        <div style={titleStyle}>Loan Officer</div>
                        <div>
                            {showOptions()}
                        </div>
                    </Col>
                </Row>
                {showNotes()}


            </div>
        </Modal>
    )
}

function AssignUnderwriter(props) {

    const [underwriterId, setUnderwriterId] = useState('')
    const handleSubmit = event => {
        updateLoanProcessor(props.loan_id, underwriterId, "Underwriter", props.onHide)
    }
    const showOptions = () => {
        const selected = e => {
            setUnderwriterId(e.target.value)
        }

        return (
            <Row className="mt-1">
                <Col className="px-0">
                    <Form.Group controlId="propertytype" className="text-left" >
                        <Form.Control name="propertytype" as="select"
                            defaultValue={props.uw_id}
                            type="text"
                            required
                            onChange={selected}
                            style={{ fontSize: 14, borderRadius: 6, border: "1px solid #ECECEC" }}
                        >
                            <option value="" >Select underwriter</option>

                            {props.underwriters.map(t => {
                                return (
                                    <option value={t.ID}>{t.FirstName} {t.LastName}</option>
                                )
                            }
                            )
                            }
                        </Form.Control>
                        <Form.Control.Feedback >Looks good!</Form.Control.Feedback>
                        <Form.Control.Feedback type="invalid" >
                            Please select underwriter.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
        )

    }
    const showNotes = () => {
        if (underwriterId === "") return <></>
        const newUWName = props.underwriters.find(t => t.ID === underwriterId).FirstName + " " + props.underwriters.find(t => t.ID === underwriterId).LastName
        if (props.uwName === newUWName) return <></>
        return (
            <Row style={{ marginTop: -10 }}>
                <Col className="px-0">
                    <div style={titleStyle}>*{newUWName} will replace {props.uwName} as the borrower's underwriter</div>
                </Col>
            </Row>
        )
    }
    const titleStyle = { fontSize: 12, color: "#6E6E70", fontWeight: 500 }
    return (
        <Modal
            {...props}
            title="Assign underwriter to the borrower"
            open={props.show}
            onCancel={props.handleClose}
            onOk={handleSubmit}
            okText="Submit"
            okButtonProps={{
                disabled: underwriterId === "",
            }}
        >
            <div className="pt-3 pb-3">

                <Row style={{ borderRadius: 6, backgroundColor: "#F5F5F7", padding: "15px 23px" }}>
                    <Col>
                        <div style={titleStyle}>Borrower</div>
                        <div>{props.name}</div>
                    </Col>
                    <Col>
                        <div style={titleStyle}>Assigned Underwriter</div>
                        <div>{props.uwName}</div>
                    </Col>
                </Row>

                <Row className="mt-3">
                    <Col className="px-0">
                        <div style={titleStyle}>Underwriter</div>
                        <div>
                            {showOptions()}
                        </div>
                    </Col>
                </Row>
                {showNotes()}


            </div>
        </Modal>
    )
}

function AssignCloser(props) {
    const [closerId, setCloserId] = useState('')
    const handleSubmit = event => {
        updateLoanProcessor(props.loan_id, closerId, "Closer", props.onHide)
    }
    const showOptions = () => {
        const selected = e => {
            setCloserId(e.target.value)
        }

        return (
            <Row className="mt-1">
                <Col className="px-0">
                    <Form.Group controlId="propertytype" className="text-left" >
                        <Form.Control name="propertytype" as="select"
                            defaultValue={props.closer_id}
                            type="text"
                            required
                            onChange={selected}
                            style={{ fontSize: 14, borderRadius: 6, border: "1px solid #ECECEC" }}
                        >
                            <option value="" >Select Closer</option>

                            {props.closer.map(t => {
                                return (
                                    <option value={t.ID}>{t.FirstName} {t.LastName}</option>
                                )
                            }
                            )
                            }
                        </Form.Control>
                        <Form.Control.Feedback >Looks good!</Form.Control.Feedback>
                        <Form.Control.Feedback type="invalid" >
                            Please select underwriter.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
        )

    }
    const showNotes = () => {
        if (closerId === "") return <></>
        const newCloserName = props.closer.find(t => t.ID === closerId).FirstName + " " + props.closer.find(t => t.ID === closerId).LastName
        if (props.closerName === newCloserName) return <></>
        return (
            <Row style={{ marginTop: -10 }}>
                <Col className="px-0">
                    <div style={titleStyle}>*{newCloserName} will replace {props.closerName} as the borrower's closer</div>
                </Col>
            </Row>
        )
    }
    const titleStyle = { fontSize: 12, color: "#6E6E70", fontWeight: 500 }
    return (
        <Modal
            {...props}
            title="Assign closer to the borrower"
            open={props.show}
            onCancel={props.handleClose}
            onOk={handleSubmit}
            okText="Submit"
            okButtonProps={{
                disabled: closerId === "",
            }}
        >
            <div className="pt-3 pb-3">

                <Row style={{ borderRadius: 6, backgroundColor: "#F5F5F7", padding: "15px 23px" }}>
                    <Col>
                        <div style={titleStyle}>Borrower</div>
                        <div>{props.name}</div>
                    </Col>
                    <Col>
                        <div style={titleStyle}>Assigned Closer</div>
                        <div>{props.closerName}</div>
                    </Col>
                </Row>

                <Row className="mt-3">
                    <Col className="px-0">
                        <div style={titleStyle}>Closer</div>
                        <div>
                            {showOptions()}
                        </div>
                    </Col>
                </Row>
                {/* {showNotes()} */}


            </div>
        </Modal>
    )
}

class Borrower extends Component {

    constructor(props) {
        super(props)
        this.state = {
            openLoanPopup: false,
            borrowers: [],
            allborrowers: [],
            loanofficers: {},
            loanprocessors: [],
            allLoanProcessors: [],
            allUnderwriters: [],
            allCloser: [],
            name: "", // borrower name for assigning loan officer
            loName: "", // loan officer name for assigning loan officer
            lpName: "", // loan processor name for assigning loan processor
            uwName: "",
            closerName: "",
            id: "",
            loanofficers_full: [],
            loading: true,
            show: false,
            bulkType: '',
            showassignlo: false,
            showassignlp: false,
            showassignuw: false,
            showassignCloser: false,
            searchText: '',
            searchedColumn: '',
            searchedText: '',
            tableFilters: {
                loanOfficer: undefined,
                loanProcessor: undefined,
                loanPurpose: undefined,
                currentStage: undefined,
                currentStatus: undefined,
                closing: undefined,
            },
            currentStatusSelectWidth: 'auto',
            currentStageSelectWidth: 'auto',
            loading: false,
            showErrorModal: false,
            editingCell: { loanID: null, columnKey: null },
            loadingStatus: false,
            firstName: '',
            lastName: '',
            isArchivedLoans: false,
            filterByLoanOfficer: false,
            selectedRowKeys: [],
            pagination: {
                current: 1,
                pageSize: 10
            },
            mismoModal: false,
            openUpdateLoanCloseAndFunded: false,
            rowData:{},
            oldStatus:'',
            applicationLink: '',
            isWideScreen: window.innerWidth >= 1470,
            isMobile: window.innerWidth < 768,
        }
        this.searchInput = React.createRef()
        this.ismobile = window.innerWidth < 576
        this.viewportWidth = window.innerWidth
        this.ishardmoneyloancustomer = com.isHardMoneyLoanCustomer()
    }

    toggleEdit = (loanID, columnKey) => {
        this.setState(prevState => ({
            editingCell: {
                loanID: prevState.editingCell.loanID === loanID && prevState.editingCell.columnKey === columnKey ? null : loanID,
                columnKey: prevState.editingCell.columnKey === columnKey && prevState.editingCell.loanID === loanID ? null : columnKey
            }
        }))
    }
    changeSeleteLos = () => {

    }
    handleOperate = (key) => {
        let ids = this.state.selectedRowKeys
        switch (key) {
            case 'status':
                this.bulkHandle('status')
                break
            case 'loanofficer':
                this.bulkHandle('loanofficer')
                break
            case 'addArchived':
                this.changeArchived(ids, 'add')
                break
            case 'delete':
                this.changeArchived(ids, 'remove')
                break
            default:
                break
        }
    }
    handleArchived = (ids, type) => {
        this.setState({ loading: true })
        let token = sessionStorage.getItem("ZeitroA")
        let body = { LoanIDs: ids }
        let api = type === 'add' ? '/los/bulkachiveloans' : '/los/bulkunachiveloans'
        fetch(api, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        }).then(response => {
            this.setState({ loading: false })
            if (response.status !== 200) {
                return
            }
            this.reload()
            const count = ids.length
            const kind = count > 1 ? 'multiple' : 'single'
            track(STATSIG.LOANS.LOAN_ARCHIVE, kind, {
                type: kind,
                count,
                loan_ids: ids,
            })
            if (type === 'add') {
                message.success('The selected loans have been archived.')
            } else {
                message.success('The selected loans have been unarchived.')
            }
            this.setState({ selectedRowKeys: [] })
        }).catch(function (err) {
            this.setState({ loading: false })
        })
    }
    bulkHandle = (type) => {
        this.setState({ bulkType: type, show: true })
    }
    handleRemoveArchived = () => {

    }
    changeArchived = (ids, type) => {
        if (type === 'add') {
            this.handleArchived(ids, 'add')
        } else {
            confirm({
                title: 'Do you want to remove the selected loans from the archived loans?',
                icon: <ExclamationCircleFilled />,
                onOk: () => {
                    this.handleArchived(ids, 'remove')
                },
                onCancel() {

                },
            })
        }
    }
    handleFilterChange = (filterType, value) => {
        console.log(filterType, value);
        this.setState(prevState => ({
            tableFilters: {
                ...prevState.tableFilters,
                [filterType]: value
            }
        }))
        this.resetPagination()
    }

    handleTableChange = (pagination) => {
        this.setState({
            pagination: {
                ...this.state.pagination,
                current: pagination.current,
                pageSize: pagination.pageSize
            }
        })
    }

    getFilteredData = () => {
        return this.reverseAndsort(this.state.borrowers.map(this.borrowersJSON)).filter(s => {
            // 过滤掉来源是 marketplace 且阶段是 leads 的数据
            if (s.sourceRaw === 'marketplace' && (s.currentStage === "leads")) {
                return false
            }
            return (
                (this.state.tableFilters.loanOfficer ? s.loanofficer === this.state.tableFilters.loanOfficer : true) &&
                (this.state.tableFilters.loanProcessor ? s.loanprocessor === this.state.tableFilters.loanProcessor : true) &&
                (this.state.tableFilters.loanPurpose ? s.purpose === this.state.tableFilters.loanPurpose : true) &&
                (this.state.tableFilters.currentStage ? s.currentStage === this.state.tableFilters.currentStage : true) &&
                (this.state.tableFilters.currentStatus ? s.currentStatus === this.state.tableFilters.currentStatus : true) &&
                (this.state.tableFilters.underwriter ? s.underwriter === this.state.tableFilters.underwriter : true) &&
                (this.state.tableFilters.closer ? s.closer === this.state.tableFilters.closer : true) &&
                (this.state.tableFilters.source ? s.source === this.state.tableFilters.source : true) &&
                matchesClosingFilter(this.state.tableFilters.closing, s.closingDate, { finished: loanHasClosed(s) })
            )   
        })
    }

    handleStatusChange = (loanID, newStatus, isFirst) => {
        this.setState({ loadingStatus: true })
        let token = sessionStorage.getItem("ZeitroA")
        let body = { LoanID: loanID, Key: "currentStatus", Value: newStatus, IsAdmin: checkAccess([UR_Owner]) ? true : false }
        fetch('/los/updatepipeline', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        }).then(response => {
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' +
                    response.status)
                this.setState({ showErrorModal: true, loadingStatus: false })
                return
            }
            this.toggleEdit(null, null)
            const updatedBorrowers = this.state.borrowers.map(borrower => {
                if (borrower.loan_id === loanID) {
                    return { ...borrower, currentStatus: newStatus }
                }
                return borrower
            })
            const stateJson = { borrowers: updatedBorrowers, loadingStatus: false };
            //isFirst只能手动change才可弹出
            if ((newStatus==='LoanFunded' || ['ApprovedButNotAccepted', "PreApprovalRequestedDenied", "CounterOfferDenied", 'Withdrawn', 'ClosedForIncompleteness', 'Denied', 'Other'].includes(newStatus)) && !isFirst){
                stateJson.openUpdateLoanCloseAndFunded = true;
                stateJson.oldStatus = newStatus;
            }else{
                stateJson.oldStatus = '';
            }
            this.setState(stateJson)
        })
            .catch(function (err) {
                console.log('Fetch Error :-S', err)
            })
    }

    handleStageChange = (loanID, newStage) => {
        this.setState({ loadingStatus: true });
        let token = sessionStorage.getItem("ZeitroA");
        let body = {
          LoanID: loanID,
          Key: "currentStage",
          Value: newStage,
          IsAdmin: checkAccess([UR_Owner]) ? true : false,
        };
        fetch("/los/updatepipeline", {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " +
                response.status
            );
            this.setState({ showErrorModal: true, loadingStatus: false });
            return;
          }
          this.toggleEdit(null, null);

          const borrower = this.state.borrowers.find((b) => b.loan_id === loanID);
          let currentStatus = borrower.currentStatus;
          const applicableStatuses =
            com.CurrentStatusUtils.getStatusesByStage(newStage);
          if (
            !applicableStatuses.some(
              (status) => status.name === currentStatus
            )
          ) {
            const firstApplicableStatus = applicableStatuses[0].name;
            currentStatus = firstApplicableStatus;
            this.handleStatusChange(loanID, firstApplicableStatus, true);
          }
          const updatedBorrowers = this.state.borrowers.map((borrower) => {
            if (borrower.loan_id === loanID) {
              return { ...borrower, currentStage: newStage, currentStatus };
            }
            return borrower;
          });
          this.setState({
            borrowers: updatedBorrowers,
            loadingStatus: false,
          });
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
        });
    }

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        })
    };

    handleReset = (clearFilters) => {
        clearFilters()
        this.setState({ searchText: '' })
    };

    getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={this.searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && this.handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false })
                            this.setState({
                                searchText: selectedKeys[0],
                                searchedColumn: dataIndex,
                            })
                        }}
                    >
                        Filter
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close()
                        }}
                    >
                        Close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => this.searchInput.current?.select(), 100)
            }
        },
        render: (text) =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    componentDidMount() {
        if ((this.props.location?.pathname || '').includes('active-loans')) {
            track(STATSIG.COMMON.VIEW, PAGE.LOANS, { page: PAGE.LOANS })
        }
        this.handleTableResize = () => {
            this.setState({
                isWideScreen: window.innerWidth >= 1470,
                isMobile: window.innerWidth < 768
            })
        }
        window.addEventListener('resize', this.handleTableResize)
        this.reload()
        this.getProfile()
        if (checkAccess([UR_Owner, UR_LoanOfficer])) {
            this.getApplicationLink()
        }
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleTableResize)
    }

    getApplicationLink = () => {
        let token = sessionStorage.getItem("ZeitroA")
        fetch("/los/getappurl", {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
            },
        }).then((response) => {
            if (response.status !== 200) {
                return
            }
            response.json().then((r) => {
                if (r && r.AppUrl) {
                    const customerId = com.getCustomerId()
                    const loId = com.getLoId()
                    const link = `${r.AppUrl}/services/preapp?customerid=${customerId}&loid=${loId}`
                    this.setState({ applicationLink: link })
                }
            })
        }).catch(() => {})
    }
    copyApplicationLink = () => {
        if (!this.state.applicationLink) {
            message.error('Application link is not available yet.')
            return
        }
        navigator.clipboard.writeText(this.state.applicationLink)
            .then(() => {
                track(STATSIG.LOANS.CREATE_NEW_LOAN_BUTTON, 'link', { type: 'link' })
                message.success('Application link copied!')
            })
            .catch(() => {
                message.error('Failed to copy application link.')
            })
    }
    getAllLoanProcessor = async () => {
        try {
            let token = sessionStorage.getItem("ZeitroA")
            const response = await fetch('/los/getloanprocessorslist', {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache"
                }
            })
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' +
                    response.status)
                this.setState({ loading: false })
                return
            }
            const js = await response.json()
            let lp = js.AllLP.map(s => {
                return s.FirstName + " " + s.LastName
            })
            this.setState({ loanprocessors: lp, allLoanProcessors: js.AllLP })
        } catch (error) {
            this.setState({ loading: false })
            console.log('Fetch Error :-S', error)
        }
    }

    getAssignedLoanProcessor = async () => {
        try {
            let token = sessionStorage.getItem("ZeitroA")
            const response = await fetch('/los/getassignedloanprocessor', {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache"
                }
            })
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' +
                    response.status)
                this.setState({ loading: false })
                return
            }
            const js = await response.json()
            let br = this.state.allborrowers.map(s => {
                let loanprocessor = "Unassigned"
                let underwriter = "Unassigned"
                let closer = "Unassigned"
                let lpsid = ""
                let underwriterid = ""
                let closerid = ""
                for (let lp in js.AssignedLPs) {
                    if (s.loan_id == js.AssignedLPs[lp].LoanID) {
                        this.state.allLoanProcessors.map(l => {
                            if (l.ID == js.AssignedLPs[lp].ID) {
                                loanprocessor = l.FirstName + " " + l.LastName
                                lpsid = l.ID
                            }
                        })
                    }
                }
                for (let u of js.AssignedUnderwriters) {
                    if (u.LoanID === s.loan_id) {
                        this.state.allUnderwriters.map(l => {
                            if (l.ID == u.ID) {
                                underwriter = l.FirstName + " " + l.LastName
                                underwriterid = l.ID
                            }
                        })
                    }
                }
                for (let clo of js.AssignedClosers) {
                    if (clo.LoanID === s.loan_id) {
                        this.state.allCloser.map(l => {
                            if (l.ID == clo.ID) {
                                closer = l.FirstName + " " + l.LastName
                                closerid = l.ID
                            }
                        })
                    }
                }
                return {
                    ...s,
                    loanprocessor: loanprocessor,
                    underwriter: underwriter,
                    closer: closer,
                    lpsid: lpsid,
                    underwriterid: underwriterid,
                    closerid: closerid
                }
            })
           
            
            this.setState({ borrowers: br, allborrowers: br, loading: false })
        } catch (error) {
            this.setState({ loading: false })
            console.log('Fetch Error :-S', error)
        }
    }
    getProfile = () => {
        let token = sessionStorage.getItem("ZeitroA")
        fetch('/los/getprofile', {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        }).then(
            response => {
                if (response.status !== 200) {
                    alert('Looks like there was a problem. Please contact Zeitro for help.')
                    return
                }
                // Examine the text in the response
                response.json().then(js => {
                    if (js.Status !== "OK") {
                        alert("Error: " + js.Error)
                    } else {
                        let lo = js.LoanOfficers[0]
                        this.setState({
                            firstName: lo.FirstName, lastName: lo.LastName,
                        })
                    }
                })
            }
        ).catch(function (err) {
        })
    }

    getLoanofficers = async () => {
        try {
            let token = sessionStorage.getItem("ZeitroA")
            const response = await fetch('/los/loanofficerlist', {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache",
                    "X-Image-Free": "true",
                }
            })
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' +
                    response.status)
                alert('Looks like there was a problem. Please try later.')
                this.setState({ loading: false })
                return
            }
            const js = await response.json()
            if (js.Status !== "OK") {
                console.log("Error: " + js.Text)
            } else {
                let docs = js.LoanOfficers.filter(el => el.Roles.includes(UR_LoanOfficer))
                docs = docs.map(s => {
                    let lo = this.state.loanofficers
                    lo[s.ID] = s.FirstName + " " + s.LastName
                    this.setState({ loanofficers: lo })
                    return {
                        rand: Math.random(), id: s.ID, email: s.Email,
                        firstname: s.FirstName, lastname: s.LastName, phone: s.Phone, image: s.Image === "" ? "/avatar.png" : s.Image
                    }
                })
                let underwriters = js.LoanOfficers.filter(el => el.Roles.includes(UR_Underwriter))
                let closers = js.LoanOfficers.filter(el => el.Roles.includes(UR_Closer))
                this.setState({ loanofficers_full: docs, allCloser: closers, allUnderwriters: underwriters })
            }
            let br = this.state.borrowers.map(s => {
                let lo = "Unassigned"
                if (this.state.loanofficers[s.los_id])
                    lo = this.state.loanofficers[s.los_id]

                return { ...s, loanofficer: lo, rand: Math.random() }
            })
            this.setState({ borrowers: br, allborrowers: br })
        } catch (error) {
            console.log('Fetch Error :-S', error)
            this.setState({ loading: false })
        }
    }
    reload = async () => {
        this.setState({ loading: true })
        let token = sessionStorage.getItem("ZeitroA")
        try {
            const response = await fetch('/los/v2/loansformanagement', {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache"
                }
            })
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' +
                    response.status)
                this.setState({ loading: false })
                return
            }
            const js = await response.json()
            if (js.Status !== "OK") {
                console.log("Error: " + js.Text)
            } else {
                if (js.Borrowers) {
                    let docs = js.Borrowers.map(s => {
                        return {
                            rand: Math.random(), id: s.ID, loan_id: s.LoanID, firstname: s.FirstName,
                            lastname: s.LastName,
                            email: s.Email, 
                            currentStatus: String(s.CurrentStatus || "").trim() || "ApplicationStarted",
                            currentStage: String(s.CurrentStage || "").trim() || "Application",
                            receivedDate: s.ReceivedDate, phone: s.ContactPhone,
                            los_id: s.LoanOfficerID,
                            purpose: s.LoanPurpose,
                            hascontract: s.HasContract,
                            unknownpurpose: s.UnknownPurpose,
                            address: s.PropertyAddressStreet,
                            county: s.PropertyAddressCounty,
                            state: s.PropertyAddressState,
                            loanstatus: s.LoanStatus,
                            typeofmortgage: s.TypeOfMortgage,
                            source: sourceNameMap[s.Source],
                            sourceRaw: s.Source, // 保存原始 Source 字段用于过滤
                            hasNoticeOfAction: s.HasNoticeOfAction,
                            hasCoborrower: s.HasCoborrower || '',
                            coBorrowers: mapCoBorrowersFromApi(s.CoBorrowers),
                            closingDate: s.ClosingDate || '',
                            loanAmount: s.LoanAmount || '',
                        }
                    })
                    // 过滤掉来源是 marketplace 且阶段是 leads 的数据
                    docs = docs.filter(s => !(s.sourceRaw === 'marketplace' && s.currentStage === "leads"))
                    if (this.ishardmoneyloancustomer) {
                        docs = docs.filter(s => s.typeofmortgage === "hardmoneyloan")
                    }
                    this.setState({ borrowers: docs, allborrowers: docs })
                }
                await Promise.all([
                    this.getLoanofficers(),
                    this.getAllLoanProcessor()
                ])
                await this.getAssignedLoanProcessor()
                this.applyFilters()
            }
        } catch (error) {
            this.setState({ loading: false })
            console.log('Fetch Error :-S', error)
        }
    }
    showAssign = (id, loan_id, name, loanofficer) => {
        this.setState({ id: id, loan_id: loan_id, name: name, loName: loanofficer })
        this.setState({ showassign: true })
    }
    showAssignLO = (id, loan_id, name, loanofficer) => {
        this.setState({ id: id, loan_id: loan_id, name: name, loName: loanofficer })
        this.setState({ showassignlo: true })
    }
    showAssignLP = (id, loan_id, name, loanprocessor) => {
        this.setState({ id: id, loan_id: loan_id, name: name, lpName: loanprocessor })
        this.setState({ showassignlp: true })
    }
    showAssignUW = (id, loan_id, name, underwriter) => {
        this.setState({ id: id, loan_id: loan_id, name: name, uwName: underwriter })
        this.setState({ showassignuw: true })
    }
    showAssignCloser = (id, loan_id, name, closer) => {
        this.setState({ id: id, loan_id: loan_id, name: name, uwName: closer })
        this.setState({ showassignCloser: true })
    }
    hideAssign = () => {
        this.setState({ showassign: false })
        this.reload()
    }
    hideAssignlo = () => {
        this.setState({ showassignlo: false })
        this.reload()
    }
    hideAssignlp = () => {
        this.setState({ showassignlp: false })
        this.reload()
    }
    hideAssignUw = () => {
        this.setState({ showassignuw: false })
        this.reload()
    }
    hideAssignCloser = () => {
        this.setState({ showassignCloser: false })
        this.reload()
    }
    getPurpose = (purpose, hascontract, unknownpurpose) => {
        if (purpose === "refinance") return "Refinance"
        if (purpose === "cashoutrefinance") return "Cash-out Refinance"
        if (purpose === "purchaserehab") return 'Purchase and Rehab'
        if (purpose === "purchase") {
            if (unknownpurpose) return "TBD"
            if (!hascontract) return "Pre-qualification"
            return "Purchase"
        }
        return "TBD"
    }

    applyFilters = () => {
        const { isArchivedLoans, filterByLoanOfficer, firstName, lastName, allborrowers } = this.state
        let filteredBorrowers = allborrowers
        if (isArchivedLoans) {
            filteredBorrowers = filteredBorrowers.filter(s => s.loanstatus === "archived")
        } else {
            filteredBorrowers = filteredBorrowers.filter(s => s.loanstatus !== "archived")
        }
        if (filterByLoanOfficer) {
            filteredBorrowers = filteredBorrowers.filter(s => s.loanofficer === `${firstName} ${lastName}`)
        }
        this.setState({ borrowers: filteredBorrowers })
    }

    handleArchivedToggle = (e) => {
        const isArchived = e.key === 'archived'
        this.setState({ isArchivedLoans: isArchived, selectedRowKeys: [] }, this.applyFilters)
    }
    handleLoansToggle = (e) => {
        this.setState({ filterByLoanOfficer: e, selectedRowKeys: [] }, this.applyFilters)
    }
    borrowersJSON = (document, index) => {


        let dt = dayjs(document.receivedDate).format('MM/DD/YYYY')
        return {
            address: document.address,
            countystate: document.county + ", " + com.convertStateToAbbr(document.state),
            name: document.firstname + " " + document.lastname,
            email: document.email,
            loanofficer: document.loanofficer,
            phone: document.phone,
            currentStatus: document.currentStatus,
            currentStage: document.currentStage,
            purpose: document.purpose,
            receivedDate: dt,
            id: document.id,
            loanid: document.loan_id,
            loanprocessor: document.loanprocessor,
            purpose: this.getPurpose(document.purpose, document.hascontract, document.unknownpurpose),
            underwriter: document.underwriter,
            closer: document.closer,
            loanstatus: document.loanstatus,
            typeofmortgage: document.typeofmortgage,
            source: document.source,
            sourceRaw: document.sourceRaw, // 保留原始 Source 字段用于过滤
            hasNoticeOfAction: document.hasNoticeOfAction,
            hasCoborrower: document.hasCoborrower || '',
            coBorrowers: document.coBorrowers || [],
            closingDate: document.closingDate || '',
            state: com.convertStateToAbbr(document.state || ''),
            loanAmount: document.loanAmount || '',
        }
    }
    reverseAndsort = (array) => {
        let a = array.sort((a, b) => {
            if (com.dateFromDate(a.receivedDate) < com.dateFromDate(b.receivedDate)) {
                return -1
            }
            if (com.dateFromDate(a.receivedDate) > com.dateFromDate(b.receivedDate)) {
                return 1
            }
            return 0
        })
        let temp = []
        for (let i = a.length - 1; i >= 0; i--) {
            temp.push(a[i])
        }
        return temp
    }
    processAddress = (address) => {
        const regex = /^(.*?),\s*([A-Za-z\s]+,\s*[A-Z]{2}\s*\d{5})$/
        const match = address.match(regex)

        if (match && match.length === 3) {
            return <>
                <div>{match[1].trim()}</div>
                <div style={{ color: "#6E6E70", fontSize: 12 }}>{match[2].trim()}</div>
            </>
        } else {
            return address
        }

    }
    onRowClick = (record) => {
        const fullName = this.state.firstName + " " + this.state.lastName
        const canAccess = record.loanofficer === "Unassigned" ||
            record.loanofficer === fullName ||
            record.loanprocessor === fullName ||
            record.underwriter === fullName ||
            record.closer === fullName ||
            checkAccess([UR_Owner])
        if (canAccess) {
            return {
                onClick: () => {
                    console.log(record)

                    this.switchLoan(record.loanid, record)
                }
            }
        } else {
            return {}
        }
    }

    resetPagination = () => {
        this.setState({
            pagination: { ...this.state.pagination, current: 1 }
        })
    }

    switchLoan = (loanid, record) => {
        sessionStorage.setItem("edit", "false")
        sessionStorage.setItem("state", "{}")
        sessionStorage.setItem("originalstate", "{}")
        sessionStorage.setItem("borrowermenu", "loanSummary")
        sessionStorage.setItem("borrowObj", JSON.stringify({id: record.id, loan_id: loanid}))
        this.props.changeBorrowerLoanId(loanid)
        this.props.changeBorrowerId(record.id)
        track(STATSIG.LOANS.LOAN_OPEN, loanid, {
            source: 'list',
            target_link: `/app/borrower/${loanid}`,
        })
        this.props.history.push("/app/borrower/" + loanid)
    }
    bulkSubmit = (val) => {
        this.setState({ loading: true })
        let token = sessionStorage.getItem("ZeitroA")
        let body = null
        let api = ''
        if (this.state.bulkType === 'status') {
            // val is in the format of "stage-status"
            const [currentStage, currentStatus] = val.split('-');
            body = { LoanIDs: this.state.selectedRowKeys, Stage: currentStage, Status: currentStatus }
            api = '/los/bulk-change-loans-stage-status'
        } else {
            body = { LoanIDs: this.state.selectedRowKeys, LOID: val }
            api = '/los/bulkchangeloanofficer'
        }
        fetch(api, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        }).then(response => {
            this.setState({ loading: false })
            if (response.status !== 200) {
                return
            }
            this.reload()
            if (this.state.bulkType === 'loanofficer') {
                const loanIds = this.state.selectedRowKeys
                const count = loanIds.length
                const kind = count > 1 ? 'multiple' : 'single'
                track(STATSIG.LOANS.LOAN_ASSIGN, kind, {
                    type: kind,
                    count,
                    loan_ids: loanIds,
                })
            }
            message.success(`change success`)
            this.setState({ selectedRowKeys: [], show: false })
        }).catch(function (err) {
            this.setState({ loading: false })
        })
    }
    handleCreateLoanDropdownOpen = (open) => {
        if (open) {
            track(STATSIG.LOANS.CREATE_NEW_LOAN_BUTTON, 'click_open_dropdown', {
                type: 'click_open_dropdown',
            })
        }
    }
    handleCreateLoan = (e) => {
        if (e.key === 'manually') {
            track(STATSIG.LOANS.CREATE_NEW_LOAN_BUTTON, 'create_manually', {
                type: 'click',
                method: 'create_manually',
            })
            this.setState({
                openLoanPopup: true
            })
        } else {
            track(STATSIG.LOANS.CREATE_NEW_LOAN_BUTTON, 'mismo_file', {
                type: 'click',
                method: 'mismo_file',
            })
            this.setState({
                mismoModal: true
            })
        }
    }
    mismoModalCancel = () => {
        this.setState({
            mismoModal: false
        })
    }
    render() {
        const { openUpdateLoanCloseAndFunded } = this.state;
        const rowSelection = {
            selectedRowKeys: this.state.selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({ selectedRowKeys })
            }
        }
        let operateBtn = this.state.isArchivedLoans ? [
            {
                key: 'delete',
                tips: 'Unarchive loans'
            },
        ] : [
            {
                key: 'status',
                tips: 'Change current stage and status'
            },
            {
                key: 'loanofficer',
                tips: 'Change selected loan officer'
            },
            {
                key: 'addArchived',
                tips: 'Archive loans'
            }
        ]
        const dropdownItems = this.state.isArchivedLoans ? [
            {
                label: 'All Loans',
                key: 'all',
            },
        ] : [
            {
                label: 'Archived Loans',
                key: 'archived',
            }
        ]
        const createLoanDropdown = [
            {
                label: 'Create manually',
                key: 'manually',
            },
            {
                label: 'Import MISMO file',
                key: 'import',
            }
        ]
        const showApplicationLink = checkAccess([UR_Owner, UR_LoanOfficer])
        const displayLink = (this.state.applicationLink || '').replace(/^https?:\/\//, '')
        const renderCreateLoanDropdown = (menu) => (
            <div className="create-loan-dropdown">
                {showApplicationLink && (
                    <div className="create-loan-dropdown-link-section">
                        <div className="create-loan-dropdown-link-label">
                            Application link for borrower
                        </div>
                        <div className="create-loan-dropdown-link-row">
                            <Tooltip title={this.state.applicationLink || ''} placement="top">
                                <div className="create-loan-dropdown-link-text">
                                    {displayLink || 'Loading link...'}
                                </div>
                            </Tooltip>
                            <img
                                className="create-loan-dropdown-link-copy"
                                src="/images/copy-blue.svg"
                                alt="Copy"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    this.copyApplicationLink()
                                }}
                            />
                        </div>
                    </div>
                )}
                {React.cloneElement(menu, {
                    style: { boxShadow: 'none', border: 'none' },
                })}
            </div>
        )
        let columns = [
          {
            title: "Loan Address",
            dataIndex: "address",
            key: "address",
            width: 160,
            ...(this.state.isMobile ? {} : { fixed: 'left' }),
            render: (text, record) => (
              <div style={{ paddingLeft: "10px", backgroundColor: "inherit" }}>
                {record.loanofficer === "Unassigned" ||
                record.loanofficer ===
                  this.state.firstName + " " + this.state.lastName ||
                record.loanprocessor ===
                  this.state.firstName + " " + this.state.lastName ? (
                  <div
                    className="clickableText"
                    onClick={() => this.switchLoan(record.loanid, record)}
                  >
                    {record.address === "" ? (
                      <span style={{ color: "#6E6E70" }}>--</span>
                    ) : (
                      this.processAddress(record.address)
                    )}
                  </div>
                ) : (
                  <div className="unclickableText">
                    {record.address === "" ? (
                      <span style={{ color: "#6E6E70" }}>--</span>
                    ) : (
                      this.processAddress(record.address)
                    )}
                  </div>
                )}
              </div>
            ),

            filteredValue: [this.state.searchedText],
            onFilter: (value, record) => {
              const coBorrowerText = (record.coBorrowers || [])
                .map((coBorrower) => `${coBorrower.name} ${coBorrower.email}`)
                .join(" ")
                .toLowerCase()
              return (
                String(record.address)
                  .toLowerCase()
                  .includes(value.toLowerCase()) ||
                String(record.name)
                  .toLowerCase()
                  .includes(value.toLowerCase()) ||
                String(record.email)
                  .toLowerCase()
                  .includes(value.toLowerCase()) ||
                String(record.purpose)
                  .toLowerCase()
                  .includes(value.toLowerCase()) ||
                String(record.currentStatus)
                  .toLowerCase()
                  .includes(value.toLowerCase()) ||
                String(record.receivedDate)
                  .toLowerCase()
                  .includes(value.toLowerCase()) ||
                coBorrowerText.includes(value.toLowerCase())
              );
            },
            responsive: ["md"],
          },
          {
            title: "Primary borrower",
            dataIndex: "name",
            key: "name",
            width: 140,
            ...(this.state.isMobile ? {} : { fixed: 'left' }),
            sorter: (a, b) => {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }
              return 0;
            },
            render: (text) => <span style={{ fontWeight: 600 }}>{text}</span>,
          },
          {
            title: "Co-borrower(s)",
            dataIndex: "coBorrowers",
            key: "coBorrowers",
            width: 170,
            render: (coBorrowers = [], record) => {
              if (!coBorrowers || coBorrowers.length === 0) {
                return <span style={{ color: "#6E6E70" }}>—</span>
              }
              const first = coBorrowers[0]
              const extra = coBorrowers.length - 1
              const needsInfo = coBorrowers.some(
                (coBorrower) => !isCoborrowerInfoComplete(coBorrower.completedSteps, record.hasCoborrower)
              )
              return (
                <div className="active-loans-coborrowers-cell">
                  <div className="active-loans-coborrowers-names">
                    <span className="active-loans-coborrowers-name" title={first.name}>{first.name}</span>
                    {extra > 0 ? <span className="active-loans-coborrowers-extra">+{extra}</span> : null}
                  </div>
                  {needsInfo ? (
                    <Tooltip title="Needs co-borrower info" placement="top">
                      <div
                        className="active-loans-coborrowers-needs-info"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Needs co-borrower info
                      </div>
                    </Tooltip>
                  ) : null}
                </div>
              )
            },
            sorter: (a, b) => {
              const aNames = (a.coBorrowers || []).map((coBorrower) => coBorrower.name).join(" ")
              const bNames = (b.coBorrowers || []).map((coBorrower) => coBorrower.name).join(" ")
              return aNames.localeCompare(bNames)
            },
          },
          // {
          //     title: 'Email',
          //     dataIndex: 'email',
          //     key: 'email',
          //     sorter: (a, b) => {
          //         if (a.email < b.email) {
          //             return -1
          //         }
          //         if (a.email > b.email) {
          //             return 1
          //         }
          //         return 0
          //     }
          // },
          {
            title: "State",
            dataIndex: "state",
            key: "state",
            width: 80,
            sorter: (a, b, sortOrder) => compareState(a.state, b.state, sortOrder),
            sortDirections: ["ascend", "descend"],
            render: (text) => text ? text : <span style={{ color: "#6E6E70" }}>—</span>,
          },
          {
            title: "Loan Purpose",
            dataIndex: "purpose",
            key: "purpose",
            width: 120,
            sorter: (a, b) => {
              if (a.purpose < b.purpose) {
                return -1;
              }
              if (a.purpose > b.purpose) {
                return 1;
              }
              return 0;
            },
          },
          {
            title: "Loan Amount",
            dataIndex: "loanAmount",
            key: "loanAmount",
            width: 110,
            sorter: (a, b, sortOrder) => compareLoanAmount(a.loanAmount, b.loanAmount, sortOrder),
            sortDirections: ["descend", "ascend"],
            render: (text) => formatLoanAmount(text) || <span style={{ color: "#6E6E70" }}>—</span>,
          },
          {
            title: "Received Date",
            dataIndex: "receivedDate",
            key: "receivedDate",
            width: 120,
            render: (text) => <>{text}</>,
            sorter: (a, b) =>
              com.dateFromDate(a.receivedDate) - com.dateFromDate(b.receivedDate),
            defaultSortOrder: "descend",
            sortDirections: ["ascend", "descend", "ascend"],
            responsive: ["md"],
          },
          {
            title: "Stage",
            dataIndex: "currentStage",
            key: "currentStage",
            width: 140,
            className:'columnsStage',
            sorter: (a, b) => a.currentStage < b.currentStage ? -1 : a.currentStage > b.currentStage ? 1 : 0,
            render: (text, record) => {
            //   const items = Object.entries(com.CurrentStage).map(([key, _], idx) => {
            //     return {
            //       key: key,
            //       label: (
            //         <a
            //           onClick={(e) => {
            //             e.stopPropagation();
            //             e.preventDefault();
            //             this.handleStageChange(record.loanid, key);
            //           }}
            //         >
            //           {key}
            //         </a>
            //       ),
            //     };
            //   });

              return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-end'
                }} onClick={(e)=>{
                    e.stopPropagation();
                    e.preventDefault();
                }}>
                    <CurrentStage  
                        currentStage={record.currentStage} 
                        currentStatus={record.currentStatus} 
                        loanID={record.loanid} 
                        handleStageChange={(loanID, value)=>{
                            if (value===record.currentStage) return;
                            this.setState({rowData: {...record}});
                            this.handleStageChange(loanID, value);
                        }} isChangeRedux={false}/>
                    {/* <StageForm 
                        loanID={record.loanid} 
                        currentStage={record.currentStage} 
                        currentStatus={record.currentStatus}
                        formItemProps={{noStyle:true}}
                        colNum={6}
                        onChange={(key)=>{
                            
                            this.handleStageChange(record.loanid, key);
                        }}
                    /> */}
                  {/* <Tag
                    bordered={false}
                    style={{
                        border: "1px solid #ECECEC",
                        backgroundColor: "white",
                        color: "#222222",
                    }}
                    className="loansStageTag"
                  >
                    {record.currentStage}
                  </Tag>
                  <Dropdown
                    menu={{
                      items,
                      style: { maxHeight: "300px", overflowY: "auto" },
                    }}
                    placement="bottomLeft"
                    arrow
                  >
                    <Button
                      className="loanStageSelect"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.toggleEdit(record.loanid, "currentStage");
                      }}
                    >
                      <CaretDownOutlined style={{ fontSize: 11 }} />
                    </Button>
                  </Dropdown> */}
                </div>
              );
            },
            sortDirections: ["descend", "ascend"],
          },
          {
            title: "Status",
            dataIndex: "currentStatus",
            key: "currentStatus",
            width: 190,
            sorter: (a, b) =>
              a.currentStatus < b.currentStatus
                ? -1
                : a.currentStatus > b.currentStatus
                ? 1
                : 0,
            className:'columnsStage',
            render: (_, record) => {
            //   const items = 
            //     com.CurrentStatusUtils.getStatusesByStage(record.currentStage, record.purpose)
            //   .map(({ code, name }, idx) => {
            //     return {
            //       key: code,
            //       label: (
            //         <a
            //           onClick={(e) => {
            //             e.stopPropagation();
            //             e.preventDefault();
            //             this.handleStatusChange(record.loanid, name);
            //           }}
            //         >
            //           {com.CurrentStatusUtils.getStatusName(name)}
            //         </a>
            //       ),
            //     };
            //   });

              return (
                <div className="loansStatus" onClick={(e)=>{
                    e.stopPropagation();
                    e.preventDefault();
                }}>
                    <CurrentStatus
                        currentStage={record.currentStage} 
                        currentStatus={record.currentStatus} 
                        loanID={record.loanid} 
                        handleStatusChange={(loanID, value)=>{
                            if (value===this.state.oldStatus) return; //oldStatus，记录为了只触发一次弹框
                            this.setState({rowData: {...record}})
                            this.handleStatusChange(record.loanid, value);
                        }}
                        isChangeRedux={false}/>
                     {/* <StatusForm 
                        loanID={record.loanid} 
                        currentStage={record.currentStage} 
                        currentStatus={record.currentStatus}
                        formItemProps={{noStyle:true}}
                        onChange={(key)=>{
                            
                            this.handleStageChange(record.loanid, key);
                        }}
                    /> */}
                  {/* <Tag
                    bordered={false}
                    style={{ 
                        backgroundColor: com.CurrentStatusUtils.getStatusBackgroundColor(record.currentStatus),
                        color: com.CurrentStatusUtils.getStatusTextColor(record.currentStatus),
                    }}
                    className="loansStatusTag"
                  >
                    {com.CurrentStatusUtils.getStatusName(record.currentStatus)}
                  </Tag>
                  <Dropdown
                    menu={{
                      items,
                      style: { maxHeight: "300px", overflowY: "auto" },
                    }}
                    placement="bottomLeft"
                    arrow
                  >
                    <Button
                      className="loanStatusSelect"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.toggleEdit(record.loanid, "currentStatus");
                      }}
                    >
                      <CaretDownOutlined style={{ fontSize: 11 }} />
                    </Button>
                  </Dropdown> */}
                </div>
              );
            },
            sortDirections: ["descend", "ascend"],
          },
        ];
        // Only while the Closing filter is on: the loans it lists show their
        // date and its flag, and the rest of the time the table is narrower.
        if (this.state.tableFilters.closing) {
            columns.push({
                title: "Close of escrow date",
                dataIndex: "closingDate",
                key: "closingDate",
                width: 150,
                sorter: (a, b, sortOrder) => compareCloseOfEscrow(a.closingDate, b.closingDate, sortOrder),
                sortDirections: ["ascend", "descend"],
                render: (text, record) => {
                    if (!text) return <span style={{ color: "#6E6E70" }}>—</span>
                    const flag = closeOfEscrowFlag(text, { finished: loanHasClosed(record) })
                    return (
                        <div className="active-loans-closing-date">
                            <span>{text}</span>
                            {flag ? (
                                <Tag bordered={false} color={flag.kind === "overdue" ? "error" : "warning"} className="active-loans-closing-flag">
                                    {flag.label}
                                </Tag>
                            ) : null}
                        </div>
                    )
                },
            })
        }
        if (checkAccess([UR_Owner])) {     // owners have the ability to see loans and assigned members, also be able to assign and reassign
            columns.push(
                {
                    title: "Loan Officer",
                    dataIndex: "loanofficer",
                    key: "loanofficer",
                    width: 130,
                    sorter: (a, b) => {
                        if (a.loanofficer < b.loanofficer) {
                            return -1
                        }
                        if (a.loanofficer > b.loanofficer) {
                            return 1
                        }
                        return 0
                    },

                    render: (_, row) => (
                        <div>
                            {row.loanofficer === "Unassigned" ?
                                <Button
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        this.showAssignLO(row.id, row.loanid, row.name, row.loanofficer)
                                    }}
                                    className="loansAddLOButton">Add</Button>
                                :
                                <a
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        this.showAssignLO(row.id, row.loanid, row.name, row.loanofficer)
                                    }}
                                    style={{ textDecoration: "underline", fontWeight: 500 }}
                                >
                                    {row.loanofficer}
                                </a>}

                        </div>
                    ),
                },
                {
                    title: 'Processor',
                    width: 130,
                    align:'center',
                    dataIndex: 'loanprocessor',
                    key: 'loanprocessor',
                    sorter: (a, b) => {
                        if (a.loanprocessor < b.loanprocessor) {
                            return -1
                        }
                        if (a.loanprocessor > b.loanprocessor) {
                            return 1
                        }
                        return 0
                    },

                    responsive: ['md'],
                    render: (_, row) => (
                        <div>
                            {row.loanprocessor === "Unassigned" ?
                                <Button
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        this.showAssignLP(row.id, row.loanid, row.name, row.loanprocessor)
                                    }}
                                    className="loansAddLOButton">Add</Button>
                                :
                                <a
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        this.showAssignLP(row.id, row.loanid, row.name, row.loanprocessor)
                                    }}
                                    style={{ textDecoration: "underline", fontWeight: 500 }}
                                >
                                    {row.loanprocessor}
                                </a>}

                        </div>
                    ),
                }
            )
        }
        if (this.ishardmoneyloancustomer) {      // for the client yeelee specifically, hard money loans have more roles (closer, underwriter...)
            columns.push({
                title: 'Underwriter',
                dataIndex: 'underwriter',
                key: 'underwriter',
                width: 130,
                sorter: (a, b) => {
                    if (a.underwriter < b.underwriter) {
                        return -1
                    }
                    if (a.underwriter > b.underwriter) {
                        return 1
                    }
                    return 0
                },

                responsive: ['md'],
                render: (_, row) => (
                    <div>
                        {row.underwriter === "Unassigned" ?
                            <Button
                                onClick={(e) => {
                                    e.stopPropagation()
                                    this.showAssignUW(row.id, row.loanid, row.name, row.underwriter)
                                }}
                                className="loansAddLOButton">Add</Button>
                            :
                            <a
                                onClick={(e) => {
                                    e.stopPropagation()
                                    this.showAssignUW(row.id, row.loanid, row.name, row.underwriter)
                                }}
                                style={{ textDecoration: "underline", fontWeight: 500 }}
                            >
                                {row.underwriter}
                            </a>}

                    </div>
                ),
            },
                {
                    title: 'Closer',
                    dataIndex: 'closer',
                    key: 'closer',
                    width: 130,
                    sorter: (a, b) => {
                        if (a.closer < b.closer) {
                            return -1
                        }
                        if (a.closer > b.closer) {
                            return 1
                        }
                        return 0
                    },

                    responsive: ['md'],
                    render: (_, row) => (
                        <div>
                            {row.closer === "Unassigned" ?
                                <Button
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        this.showAssignCloser(row.id, row.loanid, row.name, row.closer)}}
                                    className="loansAddLOButton">Add</Button>
                                :
                                <a
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        this.showAssignCloser(row.id, row.loanid, row.name, row.closer)
                                    }}
                                    style={{ textDecoration: "underline", fontWeight: 500 }}
                                >
                                    {row.closer}
                                </a>}

                        </div>
                    ),
                })
        }
        if (com.getCustomerId() === "ratedna") {    //  for the client ratedna specifically, to track source of the loan
            columns.push({
                title: 'Loan Source',
                dataIndex: 'source',
                key: 'source',
                width: 130,
            })
        }
        // No width, so the table gives it whatever the screen has beyond the
        // columns' widths: the columns stay together on the left and Archive
        // stays at the right edge, instead of every column stretching.
        columns.push(
            {
                title: '',
                key: 'spacer',
                className: 'loansTableSpacer',
                render: () => null,
            },
            {
                width: 80,
                title: 'Archive',
                align:'center',
                dataIndex: 'archive',
                key: 'archive',
                render: (text, record) => {
                    return !this.state.isArchivedLoans ? <img onClick={(event) => {
                        console.log(record)

                        event.stopPropagation()

                        this.changeArchived([record.loanid], 'add')

                    }} src="/images/archive.svg"></img> : <img
                        onClick={(event) => {
                            event.stopPropagation()
                            this.changeArchived([record.loanid], 'remove')

                        }}
                        src="/images/unDownload.svg"></img>
                }
            }
        )
        // console.log(this.getFilteredData(), 999)
         let configurations = JSON.parse(
            localStorage.getItem("configurations") || "{}"
        );
        return (

            <>
                <div className="loansTable text-left  mx-0 w-100 " style={{ MinHeight: '100vh',height:"100%", background: "#f6F6F6" }}>
                    <div className="LoansTitle  d-flex justify-content-between align-items-center">
                        <div style={{ color: "#000", fontSize: 18, fontFamily: 'Inter', marginLeft: 24 ,flex: 1}} >
                            {/* <span>{this.state.isArchivedLoans ? 'Archived Loans' : 'All Loans'}</span> */}
                            All Loans
                            {/* <Dropdown
                            className="document-dropdown"
                            menu={{
                                items: dropdownItems,
                                onClick: (e) => this.handleArchivedToggle(e)
                            }}
                            trigger={['click']}
                        >
                            <img style={{ width: 28, height: 28, cursor: 'pointer' }} className="document-more" src="/images/document-more.svg" />
                        </Dropdown> */}
                        </div>
                        <TodoIcon/>
                        {!this.ishardmoneyloancustomer && checkAccess([UR_LoanOfficerManager, UR_LoanOfficer, UR_Owner]) && (
                            <Dropdown
                                overlayClassName="create-loan-dropdown-overlay"
                                menu={{
                                    items: createLoanDropdown,
                                    onClick: (e) => this.handleCreateLoan(e)
                                }}
                                dropdownRender={renderCreateLoanDropdown}
                                placement="bottomRight"
                                trigger={['click']}
                                onOpenChange={this.handleCreateLoanDropdownOpen}
                            >
                                <Button type="primary" style={{ marginRight: 24, fontSize: 16, fontFamily: 'Inter', lineHeight: 'normal', display: 'flex', alignItems: 'center' }}>Create new loan</Button>
                            </Dropdown>
                        )}
                        {
                            this.ishardmoneyloancustomer && checkAccess([UR_LoanOfficerManager, UR_LoanOfficer, UR_Owner]) && (
                                <Button type="primary" onClick={() => this.handleCreateLoan({key: 'manually'})} style={{ marginRight: 24, fontSize: 16, fontFamily: 'Inter', lineHeight: 'normal', display: 'flex', alignItems: 'center' }}>Create new loan</Button>
                            )
                        }
                    </div>
                    <div className="loansContent">
                        {
                            this.state.selectedRowKeys.length > 0 ? (
                                <div className="multiple-bar">
                                    <div className="document-total"><CloseOutlined onClick={() => this.setState({ selectedRowKeys: [] })} style={{ fontSize: 12, marginRight: 12, cursor: 'pointer' }} /> <span className="document-num">{this.state.selectedRowKeys.length} selected</span></div>
                                    <div className="document-operate">
                                        {
                                            operateBtn.map(item => {
                                                return (
                                                    <Tooltip placement="bottom" title={item.tips} arrow={false}>
                                                        <div className="document-operate-btn" onClick={() => this.handleOperate(item.key)}>
                                                            <img src={`/images/document-${item.key}.svg`} />
                                                        </div>
                                                    </Tooltip>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            ) : (
                                <div className="loansFilter borrowerFilter">
                                    <div className="d-flex  align-items-center borrower-filter-com">
                                        <Input.Search
                                            className="newLoansSearchbar"
                                            placeholder="Search by any field"
                                            style={{ minWidth: "180px" }}
                                            onSearch={value => this.setState({ searchedText: value })}
                                            allowClear
                                        />
                                        {checkAccess([UR_Owner]) &&
                                            <>
                                                <Select
                                                    className={this.ismobile ? "loansFilters-xs" : "newLoansFilters"}
                                                    placeholder="Loan Officer"
                                                    onChange={(value) => this.handleFilterChange('loanOfficer', value)}
                                                    allowClear
                                                >
                                                    {Array.from(new Set(Object.values(this.state.loanofficers))).map(s => (
                                                        <Select.Option key={s} value={s}>{s}</Select.Option>
                                                    ))}
                                                    <Select.Option key={"Unassigned"} value={"Unassigned"}>Unassigned</Select.Option>
                                                </Select>
                                                {/* <Select
                      className={this.ismobile ? "loansFilters-xs" : "loansFilters"}
                      placeholder="Loan Processor"
                      onChange={(value) => this.handleFilterChange('loanProcessor', value)}
                      allowClear
                    >
                      {Array.from(new Set(Object.values(this.state.loanprocessors))).map(s => (
                        <Select.Option key={s} value={s}>{s}</Select.Option>
                      ))}
                      <Select.Option key={"Unassigned"} value={"Unassigned"}>Unassigned</Select.Option>
                    </Select> */}
                                            </>
                                        }
                                        <Select
                                            className="newLoansFilters"
                                            placeholder="Loan Purpose"
                                            onChange={(value) => this.handleFilterChange('loanPurpose', value)}
                                            allowClear
                                        >
                                            {["Purchase", "Pre-qualification", "Refinance", "Cash-out Refinance", "TBD"].map(s => (
                                                <Select.Option key={s} value={s}>{s}</Select.Option>
                                            ))}
                                        </Select>
                                        <Select
                                            className="newLoansFilters"
                                            placeholder="Stage"
                                            style={{ minWidth: "120px" }}
                                            onChange={(value) => this.handleFilterChange('currentStage', value)}
                                            allowClear
                                            options={
                                                Object.entries(com.CurrentStage).map(([stageName]) => ({
                                                    label: stageName,
                                                    value: stageName
                                                }))
                                            }
                                        />
                                        <Select
                                            className="newLoansFilters"
                                            placeholder="Status"
                                            style={{ minWidth: "140px" }}
                                            onChange={(value) => this.handleFilterChange('currentStatus', value && value.replace(/\s*/, ''))}
                                            allowClear
                                            options={
                                                Object.entries(com.CurrentStatus).map(([statusName]) => ({
                                                    value: statusName,
                                                    label: com.CurrentStatusUtils.getStatusName(statusName)
                                                }))
                                            }
                                        />
                                        <Select
                                            className="newLoansFilters closingFilter"
                                            placeholder="Closing"
                                            onChange={(value) => this.handleFilterChange('closing', value)}
                                            allowClear
                                            options={CLOSING_FILTERS}
                                        />
                                        {com.getCustomerId() === "ratedna" && <Select
                                            className="newLoansFilters"
                                            placeholder="Loan Source"
                                            onChange={(value) => this.handleFilterChange('source', value)}
                                            allowClear
                                        >
                                            {["From Sunny", "Social Media", "Friend Referral", "Website"].map(s => (
                                                <Select.Option key={s} value={s}>{s}</Select.Option>
                                            ))}
                                        </Select>}
                                    </div>
                                    {/* this.handleLoansToggle */}
                                    <div className="viewMode-bar">
                                        <div style={{ fontWeight: 600, fontSize: 16, }}>
                                            View archived loans
                                            <Switch
                                                onChange={(

                                                    e
                                                ) => {

                                                    this.setState({ isArchivedLoans: e, selectedRowKeys: [] }, this.applyFilters)

                                                }}
                                                style={{ marginLeft: '10px' }}
                                            />
                                        </div>
                                        {/* <div style={{ fontWeight: 600, fontSize: 16, }}>
                                        View loans assigned to me only
                                        <Switch
                                            onChange={this.handleLoansToggle}
                                            style={{ marginLeft: '10px' }}
                                        />
                                    </div> */}
                                    </div>
                                </div>
                            )
                        }
                        {this.state.loading ?
                            <div>
                                <Skeleton active />
                                <Skeleton active />
                                <Skeleton active />
                            </div>
                            :
                            <div className="loansTableWrap borrowerTableWrap">
                                <Table
                                    locale={{
                                        emptyText: (
                                            <div style={{ textAlign: 'center' }} className="emptyLoans">
                                                <img src='/images/empty.svg'></img>
                                                <div

                                                    style={{
                                                        margin: "10px auto",
                                                        color: '#6E6E70',
                                                        fontSize: 12,
                                                        fontFamily: 'Inter',
                                                        width: 260

                                                    }}>
                                                    {
                                                        checkAccess([UR_LoanOfficerManager, UR_LoanOfficer, UR_Owner]) ?
                                                            "You currently have no loan records. Start a new one by clicking the button below." :
                                                            "You currently have no loan records."
                                                    }
                                                </div>
                                                {!this.ishardmoneyloancustomer && checkAccess([UR_LoanOfficerManager, UR_LoanOfficer, UR_Owner]) && (
                                                    <div style={{
                                                    margin: "10px auto",

                                                    width: 260

                                                    }}>
                                                        <Dropdown
                                                            overlayClassName="create-loan-dropdown-overlay"
                                                            menu={{
                                                                items: createLoanDropdown,
                                                                onClick: (e) => this.handleCreateLoan(e)
                                                            }}
                                                            dropdownRender={renderCreateLoanDropdown}
                                                            placement="bottomRight"
                                                            trigger={['click']}
                                                            onOpenChange={this.handleCreateLoanDropdownOpen}
                                                        >
                                                            <Button type="primary" style={{ fontSize: 16, fontFamily: 'Inter', lineHeight: 'normal' }}>Create new loan</Button>
                                                        </Dropdown>
                                                    </div>
                                                )}
                                                {this.ishardmoneyloancustomer && checkAccess([UR_LoanOfficerManager, UR_LoanOfficer, UR_Owner]) && (
                                                    <div style={{
                                                        margin: "10px auto",
                                                        width: 260
                                                    }}>
                                                        <Button type="primary" onClick={() => this.handleCreateLoan({key: 'manually'})} style={{ fontSize: 16, fontFamily: 'Inter', lineHeight: 'normal' }}>Create new loan</Button>
                                                    </div>
                                                )}

                                            </div>
                                        ),
                                    }}
                                    className=" newLoansTable"
                                    rowClassName={(record, index) => {
                                        let loFullName = this.state.firstName + " " + this.state.lastName
                                        let lpFullName = this.state.firstName + " " + this.state.lastName
                                        let uwFullName = this.state.firstName + " " + this.state.lastName
                                        let closerFullName = this.state.firstName + " " + this.state.lastName
                                        let todoClass = configurations?.enableDispositionNotification &&record?.hasNoticeOfAction?'addTodo':'';
                                        if (record.loanofficer === "Unassigned" || record.loanofficer === loFullName || record.loanprocessor === lpFullName || record.underwriter === uwFullName || record.closer === closerFullName || checkAccess([UR_Owner])) {
                                            return `selectableBackground ${todoClass}`
                                        }
                                        if (record.loanofficer !== loFullName) {
                                            return `unSelectableBackground ${todoClass}`
                                        }
                                        return todoClass
                                    }}
                                    onRow={(record) => this.onRowClick(record)}
                                    columns={columns}
                                    dataSource={this.getFilteredData()}
                                    showSorterTooltip={false}
                                    rowKey={record => record.loanid}
                                    rowSelection={{
                                        type: 'checkbox',
                                        columnWidth: SELECTION_COLUMN_WIDTH,
                                        ...rowSelection,
                                    }}
                                    scroll={this.state.isWideScreen && !this.state.isMobile ? { x: 'max-content' } : { x: columnsWidth(columns, { mobile: this.state.isMobile }) }}
                                    pagination={this.state.pagination}
                                    onChange={this.handleTableChange}
                                />
                            </div>
                        }
                        <AssignLoanOfficer
                            show={this.state.showassignlo}
                            name={this.state.name}
                            loName={this.state.loName}
                            onHide={this.hideAssignlo}
                            id={this.state.id}
                            loan_id={this.state.loan_id}
                            los_id={this.state.los_id}
                            loanofficers={this.state.loanofficers_full.map(t => {
                                return { id: t.id, firstname: t.firstname, lastname: t.lastname }
                            })}
                            handleClose={() => { this.setState({ showassignlo: false }) }}
                        />
                        <AssignLoanProcessor
                            show={this.state.showassignlp}
                            name={this.state.name}
                            lpName={this.state.lpName}
                            onHide={this.hideAssignlp}
                            id={this.state.id}
                            loan_id={this.state.loan_id}
                            lp_id={this.state.lpsid}
                            loanprocessors={this.state.allLoanProcessors.map(t => {
                                return { id: t.ID, firstname: t.FirstName, lastname: t.LastName }
                            })}
                            handleClose={() => { this.setState({ showassignlp: false }) }}
                        />
                        <AssignUnderwriter
                            show={this.state.showassignuw}
                            name={this.state.name}
                            uwName={this.state.underwriter}
                            onHide={this.hideAssignUw}
                            id={this.state.id}
                            loan_id={this.state.loan_id}
                            uw_id={this.state.underwriterid}
                            underwriters={this.state.allUnderwriters}
                            handleClose={() => { this.setState({ showassignuw: false }) }}
                        />
                        <AssignCloser
                            show={this.state.showassignCloser}
                            name={this.state.name}
                            uwName={this.state.closerName}
                            onHide={this.hideAssignCloser}
                            id={this.state.id}
                            loan_id={this.state.loan_id}
                            uw_id={this.state.closerid}
                            closer={this.state.allCloser}
                            handleClose={() => { this.setState({ showassignCloser: false }) }}
                        />
                        <Modal title="An internal error has occurred"
                            open={this.state.showErrorModal}
                            onOk={() => {
                                this.setState({ showErrorModal: false })
                                this.toggleEdit(null, null)
                                this.reload()
                            }}
                            onCancel={() => this.setState({ showErrorModal: false })}>
                            <p>Please try later or contact support@zeitro.com for help.</p>
                        </Modal>
                        <BulkChangeModal
                            type={this.state.bulkType}
                            show={this.state.show}
                            LOOptions={this.state.loanofficers_full.map(t => {
                                return { id: t.id, firstname: t.firstname, lastname: t.lastname }
                            })}
                            handleSubmit={this.bulkSubmit}
                            handleClose={() => { this.setState({ show: false }) }}
                        />
                    </div>
                </div>
                <LoanBorrowerPopUp
                    submit={(value) => {
                        this.reload()
                        //   this.createNewApplication(value)
                        //         console.log(value)

                    }}
                    open={this.state.openLoanPopup} onClose={() => {

                        this.setState({
                            openLoanPopup: false
                        })
                    }}></LoanBorrowerPopUp>
                <ImportMISMOFile
                    open={this.state.mismoModal}
                    onCancel={this.mismoModalCancel}
                    statsigSource="loans"
                >
                </ImportMISMOFile>
                {openUpdateLoanCloseAndFunded && <UpdateLoanModal 
                    loanAmount={this.state.rowData?.LoanAmount}
                    isUpdateLoan={true} 
                    isHaveNotice={false} 
                    onCancel={()=>this.setState({openUpdateLoanCloseAndFunded:false})}
                    isChangeRedux={false}
                    loanId={this.state?.rowData?.loanid} 
                    detailsFn={()=>this.switchLoan(this.state.rowData?.loanid, this.state.rowData)}
                    userModifiedStatus={this.state.oldStatus}
                    />
                }
            </>
        )
    }
}

export default connect(null, mapDispatchToProps)(withRouter(Borrower))
